import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Card, CircularProgress, Grid, Stack, Typography } from '@mui/joy';
import { FileSpreadsheet } from 'lucide-react';
import { exportReportRequest, getKpiReportsRequest } from '../../../redux/actions/reportActions';

const DynamicReportSection = ({ dashboardKey, runtimeFilters = {} }) => {
  const dispatch = useDispatch();
  const { dashboardReports, reportDashboardLoading, reportExportLoading, reportDashboardError } = useSelector((state) => state.reports || {});
  const reports = Array.isArray(dashboardReports) ? dashboardReports : [];

  useEffect(() => {
    if (dashboardKey) {
      dispatch(getKpiReportsRequest(dashboardKey, runtimeFilters));
    }
  }, [dashboardKey, dispatch, runtimeFilters]);

  if (reportDashboardLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress variant="soft" />
      </Box>
    );
  }

  if (reportDashboardError) {
    return (
      <Card variant="soft" color="danger" sx={{ p: 2 }}>
        <Typography level="body-sm">
          Impossible de charger les etats Excel: {reportDashboardError}
        </Typography>
      </Card>
    );
  }

  if (!reports.length) {
    return (
      <Card
        variant="outlined"
        sx={{
          p: 2.5,
          borderRadius: '14px',
          borderColor: '#e2e8f0',
          boxShadow: '0 8px 20px rgba(15,23,42,0.06)',
          backgroundColor: '#fff',
        }}
      >
        <Typography level="body-sm" sx={{ color: '#64748b' }}>
          Aucun etat Excel configure pour ce dashboard.
        </Typography>
      </Card>
    );
  }

  return (
    <Grid container spacing={2}>
      {reports.map((report) => (
        <Grid xs={12} md={6} key={report.id}>
          <Card
            variant="outlined"
            sx={{
              p: 2.25,
              height: '100%',
              borderRadius: '14px',
              borderColor: '#e2e8f0',
              boxShadow: '0 8px 20px rgba(15,23,42,0.06)',
              backgroundColor: '#fff',
            }}
          >
            <Stack spacing={1.25}>
              <Typography level="title-md" sx={{ color: '#0f172a' }}>{report.name}</Typography>
              <Typography level="body-sm" sx={{ color: '#475569' }}>
                {report.description || 'Export dynamique pilote par configuration.'}
              </Typography>
              <Typography level="body-xs" sx={{ color: '#64748b' }}>
                Source: {report.sourceKey} | Ordre: {report.displayOrder ?? 0}
              </Typography>
            </Stack>
            <Button
              sx={{ mt: 2, alignSelf: 'flex-start', backgroundColor: '#204385', '&:hover': { backgroundColor: '#18356a' } }}
              startDecorator={<FileSpreadsheet size={16} />}
              onClick={() => dispatch(exportReportRequest(report.id, runtimeFilters))}
              loading={reportExportLoading}
            >
              Exporter Excel
            </Button>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DynamicReportSection;
